import { UserAuthWrapper } from 'redux-auth-wrapper';
import { routerActions } from 'react-router-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

const isAuthenticated = (userData) => !isEmpty(userData);
const propsMapper = ({redirect, authData, isAuthenticating, failureRedirectPath,...otherProps}) => ({
    authData,
    isAuthenticated: isAuthenticated(authData),
        ...otherProps
});
const UserIsNotAuthenticated = UserAuthWrapper({
    authSelector: state => get(state, 'account', {}),
    redirectAction: routerActions.replace,
    wrapperDisplayName: 'UserIsNotAuthenticated',
    // Want to redirect the user when they are done loading and authenticated
    predicate: user => isEmpty(get(user, 'data')),// && !get(user, 'isLoading'),
    failureRedirectPath: (state, ownProps) => ownProps.location.query.redirect || '/',
    allowRedirectBack: false,
    propsMapper
});

const UserIsNotRegistered = UserAuthWrapper({
    authSelector: state => get(state, 'account', {}),
    redirectAction: routerActions.replace,
    wrapperDisplayName: 'UserIsNotAuthenticated',
    // Want to redirect the user when they are done loading and authenticated
    predicate: user => isEmpty(get(user, 'data')),// && !get(user, 'isLoading'),
    failureRedirectPath: (state, ownProps) => ownProps.location.query.redirect || '/wizard/',
    allowRedirectBack: false,
    propsMapper
});

const UserIsAuthenticated = UserAuthWrapper({
    authSelector: state => get(state, 'account.data', {}), // how to get the user state
    redirectAction: routerActions.replace, // the redux action to dispatch for redirect
    wrapperDisplayName: 'UserIsAuthenticated', // a nice name for this auth check
    propsMapper
});

const requireAuthentication = UserIsAuthenticated;
const siteTitle = 'AccessPlace';

export { UserIsAuthenticated, UserIsNotAuthenticated, UserIsNotRegistered, siteTitle, requireAuthentication, isAuthenticated };



// WEBPACK FOOTER //
// ./src/app/containers/index.ts